import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ComplianceStatsData } from '../models';

export interface ComplianceStatsSliceState {
  data: ComplianceStatsData;
  loading: boolean;
  error: string | null;
}

const initialState: ComplianceStatsSliceState = {
  data: null,
  loading: false,
  error: null,
};

const complianceStatsSlice = createSlice({
  name: 'complianceStats',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<ComplianceStatsData>) => ({
      ...state,
      data: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    fetchCustomerStats: (state) => ({
      ...state,
      error: null,
      loading: true,
    }),
  },
});

export { complianceStatsSlice };
